import { CheckCircle, Close, MailOutline } from "@mui/icons-material";
import TextField from '@mui/material/TextField';

import { useEffect, useState } from 'react'
import { getAnalytics, logEvent } from "firebase/analytics";

import axios from 'axios';
import BottomMenu from "./BottomMenu";
import { ACCENT_COLOR } from "../constants/colors";
import { useNavigate } from "react-router-dom";



export default function RequestAppInvite(props) {
    const { } = props;

    const [errorMessage, setErrorMessage] = useState("");
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);

    const analytics = getAnalytics();
    const navigate = useNavigate();

    useEffect(() => {
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'request_app_invite'
        });
    }, []);

    const tryWebApp = () => {
        logEvent(analytics, 'web_app_click');
        navigate('/download_webapp');
    }

    const requestInvite = () => {
        const email = document.getElementById('request_invite_email').value.trim();
        setErrorMessage("");
        if (email) {
            setLoading(true);
            axios
                .post('/request_invite', {
                    email: email,
                    userAgent: navigator.userAgent,
                })
                .then((res) => {
                    setLoading(false);
                    setSuccess(res.data.success);
                })
                .catch((err) => {
                    setLoading(false);
                    if (err.response.data.error) {
                        setErrorMessage(err.response.data.error);
                    } else {
                        setErrorMessage("Unexpected error.");
                        // console.log(err.response.data.error);
                    }
                });
        } else {
            setErrorMessage("Enter your email to get your invite.");
        }
    }

    return (
        <div>
            <div style={{ padding: '30px 20px' }}>
                {!success ?
                    <div>
                        <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                            <button onClick={tryWebApp} className='blurBackground' style={{ padding: '13px 13px', borderRadius: '30px', background: 'transparent', border: 'none', color: 'var(--app-text)' }}>
                                <div style={{ fontSize: '15px', fontWeight: '500' }}>Web App</div>
                            </button>
                        </div>
                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                            <div className='homepageSectionTitle'>
                                Get your invite code.
                            </div>
                            <div className='subheading' style={{ paddingTop: '4px' }}>
                                Be the first to try the new Android app.
                            </div>
                        </div>

                        <div style={{ textAlign: 'center', padding: '20px 0px 10px' }}>
                            <img src="/app_screenshots/android_app_preview.png" alt="android" style={{ width: '100%', borderRadius: '6px', verticalAlign: 'middle' }} />
                        </div>
                        <div>

                            {loading ?
                                <div className="loader"></div>
                                :
                                errorMessage ?
                                    <div style={{ fontSize: '16px', fontWeight: '500', color: ACCENT_COLOR, textAlign: 'left', padding: '10px 0px' }}>
                                        {errorMessage}
                                    </div> :
                                    <></>
                            }
                            <TextField
                                style={{ width: '100%' }}
                                placeholder="Enter your email"
                                variant="outlined"
                                type="email"
                                id="request_invite_email"
                            />
                            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                <button onClick={requestInvite} style={{ padding: '13px 24px', borderRadius: '30px', background: 'var(--app-action)', color: 'var(--app-action-ink)' }}>
                                    <MailOutline style={{ verticalAlign: 'middle', fontSize: '20px', marginTop: '-3px', marginRight: '8px' }} />
                                    <span style={{ fontSize: '15px', fontWeight: '500' }}>
                                        Request invite
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='hasBottomMenu' style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '40px', paddingBottom: '10px' }}>
                            <CheckCircle style={{ verticalAlign: 'middle', color: 'green', fontSize: '40px' }} />
                        </div>
                        <div>
                            <span className='heading'>Thanks for signing up!</span>
                            <div style={{ fontSize: '15px', paddingTop: '20px' }}>
                                We'll send an email on the next batch of invites.

                                <div style={{ fontSize: '13px', color: 'var(--app-text-secondary)', paddingTop: '10px' }}>
                                    {success}
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: '40px', textAlign: 'center' }}>
                            <button onClick={tryWebApp} className='blurBackground' style={{ padding: '13px 24px', borderRadius: '30px', fontSize: '15px', fontWeight: '500' }}>Web App</button>
                        </div>
                        <BottomMenu />
                    </div>
                }
            </div>
        </div>
    );
}
